import { render, staticRenderFns } from "./MCPDecoration.vue?vue&type=template&id=2a0e1f64&scoped=true"
import script from "./MCPDecoration.vue?vue&type=script&lang=js"
export * from "./MCPDecoration.vue?vue&type=script&lang=js"
import style0 from "./MCPDecoration.vue?vue&type=style&index=0&id=2a0e1f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e1f64",
  null
  
)

export default component.exports